module.exports = __webpack_public_path__ + "img/main-logo.7747971f.svg";